export { default as DefaultPage } from './DefaultPage';
export { default as AcompanhamentoLogRpa } from './AcompanhamentoLogRpa';
export { default as FormFiltroLogRpa } from './FormFiltroLogRpa';



// WEBPACK FOOTER //
// ./src/features/logs-sistema/index.js